module.exports = "https://www.gc-qa.gnp.com.mx/63f3d150eb6dd2a96ee213cdb3f51eb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-3.png
// module id = 8148
// module chunks = 0